import { useState, useEffect } from 'react';
import { getUserFilters, setUserFilters } from '../services/api';

/**
 * Puzzle filters for FilterPanel.
 *
 * Fetches the filters whenever `isOpen` becomes true. `setFilters` edits them
 * locally; `saveFilters` sends them to the backend.
 *
 * @param {boolean} isOpen - whether the panel is open
 * @returns {{ filters, setFilters, loading, saving, error, saveFilters }}
 */
export const useUserFilters = (isOpen) => {
  const [filters, setFilters] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  // Fetch filters from backend when opened
  useEffect(() => {
    if (!isOpen) return;
    setLoading(true);
    getUserFilters()
      .then(f => setFilters(f))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, [isOpen]);

  /**
   * @param {Function} [onSaved] - called after a successful save
   */
  const saveFilters = async (onSaved) => {
    setSaving(true);
    try {
      await setUserFilters(filters);
      if (onSaved) onSaved();
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  };

  return { filters, setFilters, loading, saving, error, saveFilters };
};

export default useUserFilters;
